var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 text-center"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.urlLogo,"title":_vm.titlePortal}}),_c('h4',{staticClass:"text-center my-2"},[_vm._v(_vm._s(_vm.titlePortal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }